import { Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { environment } from '../../../../../environments/env';
import { AuthService } from '../../../../core/services/auth.service';
import { ThemeApplierService } from '../../../../core/services/theme-applier.service';
import { openLogoutConfirmationDialog } from '../dialog/confirm-dialog/logout-confirmation';

@Component({
  selector: 'app-header',
  imports: [MatToolbarModule, MatButtonModule, MatIconModule, MatMenuModule, RouterLink],
  templateUrl: './header.html',
  styleUrl: './header.sass',
})
export class Header {
  private authService = inject(AuthService);
  private dialog = inject(MatDialog);
  private themeApplier = inject(ThemeApplierService);
  env = environment;
  user = this.authService.currentUser;
  adminRoleId = 1;

  /** Logo do tema ativo (T06) — cai para `env.logo` quando não há personalização. */
  logoSrc = computed(() => this.themeApplier.activeLogoUrl() ?? this.env.logo);

  /** Brasão do tema ativo — sem fallback estático: `null` significa "não mostrar" (ajustes-finos-ux.md item 1). */
  emblemSrc = computed(() => this.themeApplier.activeEmblemUrl());

  getFirstAndLastName(fullName: string) {
    const partsName = fullName.trim().split(' ');

    if (partsName.length > 1) {
      const firstName = partsName[0];
      const lastNameIndex = partsName.length - 1;

      const preLastName = ['de', 'da', 'dos', 'das', 'do', 'e'].includes(
        partsName[lastNameIndex - 1].toLowerCase()
      )
        ? `${partsName[lastNameIndex - 1]} ${partsName[lastNameIndex]}`
        : partsName[lastNameIndex];

      return `${firstName} ${preLastName}`;
    }

    return fullName;
  }
  onAvatarError(event: Event): void {
    (event.target as HTMLImageElement).src = 'assets/images/avatar_null.jpg';
  }

  logout() {
    openLogoutConfirmationDialog(this.dialog).subscribe((confirmed) => {
      if (confirmed) {
        this.authService.purgeAuth();
      }
    });
  }
}
